import router from 'src/router';
import { getQueryString } from 'src/router/queryString';
import { NODE_ROUTE } from 'src/config/routes';
import baseHandler from './baseHandler';

const DEFAULT_PARAMS = { nodeId: 0 };

export default (req) => {
  const params = Object.assign({}, DEFAULT_PARAMS, req.params);
  delete params.postVerificationFlowId;
  const queryString = getQueryString();
  router.replacePath(NODE_ROUTE, params, queryString);
  baseHandler({ params });
};
